<template>
	<!-- 商品 -->
	<div class="commodity-wrapper">
		<!-- 轮播图 -->
		<info-goods-swipe></info-goods-swipe>
		<!-- 商品信息 -->
		<info-item></info-item>


		<!-- 促销信息 -->
		<info-promotions></info-promotions>
		<!-- 代金券 -->
		<div class="main-content">
			<flex-line v-if="voucher" :is-link="true" :show-border="true" @click.native="$router.push({name:'HomeStoreVoucher'})">
				<span>领取优惠券</span>
			</flex-line>
		</div>
		<!-- 店铺服务 -->
		<div class="main-content" v-if="detailInfo.store_service_list && detailInfo.store_service_list.length">
			<flex-line class="field-line" :is-link="true" :show-border="true" @click.native="showService=true">
				<span>店铺服务</span>
        <div class="field-line-right" slot="right">
          <div class="service-list">
              <div class="service-item" v-for="(item,index) in detailInfo.store_service_list" :key="index">
                <span class="service-icon iconfont">&#xe69d;</span>
                <span class="service-text">{{item.store_service_title}}</span>
              </div>
          </div>
        </div>
			</flex-line>
      <mt-popup v-model="showService" position="bottom">
          <div class="popup-service-list">
              <div class="popup-service-item" v-for="(item,index) in detailInfo.store_service_list" :key="index">
                <div class="service-item">
                  <span class="service-icon iconfont">&#xe69d;</span>
                  <span class="service-text">{{item.store_service_title}}</span>
                </div>
                <div class="service-desc">{{item.store_service_desc}}</div>
              </div>
          </div>
      </mt-popup>
		</div>
		<!-- 购买 -->
		<info-buy></info-buy>
		<!-- 自提-->
		<info-chain></info-chain>
		<!-- 联系客服-->
		 <info-contact></info-contact>
		<!-- 评论 -->
		<info-goods-review @reviewtop='getreviewtop'></info-goods-review>

		<!-- 店铺信息 -->
		<div class="goods-detail-store" @click="$router.push({name:'HomeStoredetail',query:{id:storeInfo.store_id}})">
			<div>
				<div class="store-name"><img width="40" :src="storeInfo.store_avatar">
					{{storeInfo.store_name}}

					<span class="icon-mall" v-if="storeInfo.is_platform_store">自营</span>
				</div>
				<div class="store-rate">
				<span class="equal">描述相符
					<em>{{storeInfo.store_credit.store_servicecredit.credit}}</em>
					<i>{{storeInfo.store_credit.store_servicecredit.percent_text}}</i>
				</span>
					<span class="equal">服务态度
					<em>{{storeInfo.store_credit.store_desccredit.credit}}</em>
					<i>{{storeInfo.store_credit.store_servicecredit.percent_text}}</i>
				</span>
					<span class="equal">发货速度
					<em>{{storeInfo.store_credit.store_deliverycredit.credit}}</em>
					<i>{{storeInfo.store_credit.store_servicecredit.percent_text}}</i>
				</span>
				</div>
			</div>
		</div>

		<!-- 商品搭配 -->
		<accessory-item></accessory-item>
		<!-- 商品详情  -->
		<product-desc @mbBodytop="getmbBodytop"></product-desc>
		<!-- 推荐商品  -->
		<recommend-item></recommend-item>
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import flexLine from '../../../flexLine'
import InfoGoodsSwipe from './InfoGoodsSwipe'
import InfoItem from './InfoItem'
import InfoPromotions from './InfoPromotions'
import InfoBuy from './InfoBuy'
import InfoContact from './InfoContact'
import InfoChain from './InfoChain'
import InfoGoodsReview from './InfoGoodsReview'
import RecommendItem from './RecommendItem'
import AccessoryItem from './AccessoryItem'
import ProductDesc from './ProductDesc'
import { flowstat_record } from '../../../../api/homestoredetail'

export default {
  data () {
    return {
    showService:false,
	}
  },

  created () {},

  components: {
	  flexLine,
    InfoGoodsSwipe,
    InfoItem,
    InfoPromotions,
    InfoBuy,
    InfoContact,
	InfoChain,
    InfoGoodsReview,
    RecommendItem,
	ProductDesc,
    AccessoryItem
  },

  computed: {
    ...mapState({
      storeInfo: state => state.goodsdetail.storeInfo,
      detailInfo: state => state.goodsdetail.detailInfo,
		voucher: state => state.goodsdetail.voucher
    })
  },
  created () {
    this.flowstat_record()
  },
  mounted () {},

  methods: {
      flowstat_record () {
         flowstat_record(this.storeInfo.store_id,this.detailInfo.goods_id,'Goods').then((res) => {
      })
    },
	getmbBodytop:function(top){
		this.$emit('mbBodytop',top);
	},
	getreviewtop:function(top){
		this.$emit('reviewtop',top);
	}
  }
}
</script>

<style lang="scss" scoped>
	.main-content{padding:0 $pageSpace;background-color: #fff;}
.commodity-wrapper {
	height: 100%;
}
.goods-detail-store { display: block; position: relative; z-index: 1; padding: 0 $pageSpace;background: #FFF; margin-top:$modelSpace;box-shadow: 0px 4px 4px #f7f7f7; }
.goods-detail-store .store-name { min-height: 0.9rem; padding: 0.5rem 0 0.25rem  0; font-size:$subFontSize; line-height: 0.9rem; color: #333; }
.goods-detail-store .store-name .icon-store { display: inline-block; width: 0.8rem; height: 0.9rem; vertical-align: top; margin-right: 0.2rem; }
.goods-detail-store .store-name .icon-store:before { content: "\e7dc"; }
.goods-detail-store .store-name .icon-mall { color: $primaryColor;padding:.1rem .2rem;border:1px solid $primaryColor;border-radius:.2rem;font-size:$h6; margin-left: 0.5rem;}
.goods-detail-store .store-rate { height: 0.7rem; padding: 0.4rem 0 0.5rem 0; border-top: dashed 1px #EEE; font-size: 0; }
.goods-detail-store .store-rate span { display: inline-block; width: 33.33%; height: 0.7rem; font-size:$h6; line-height: 0.7rem; color: #888; }
.goods-detail-store .store-rate span em { display: inline-block; vertical-align: middle; font-size:$subFontSize; font-weight: 600;}
.goods-detail-store .store-rate span i { display: inline-block; vertical-align: middle; width: 0.7rem; height: 0.7rem; font-size:$h6; line-height: 0.7rem; font-style: normal; text-align: center; border-radius: 0.1rem;margin-left:0.2rem;}
.goods-detail-store .store-rate span.high em,
.goods-detail-store .store-rate span.equal em { color: $primaryColor;}
.goods-detail-store .store-rate span.high i,
.goods-detail-store .store-rate span.equal i { color: #FFF; background-color: $primaryColor}
.goods-detail-store .store-rate span.low em { color: #48CFAE;}
.goods-detail-store .store-rate span.low i { color: #FFF; background-color: #48CFAE;}


.service-list{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;display:flex;flex-wrap:wrap;padding-left:.5rem;height:1rem;line-height:1rem;}
    .service-item{display:flex;align-items:center;padding-right:.5rem;
        .service-icon{font-size:$subFontSize;color:$primaryColor;padding-right:.2rem;}
        .service-text{font-size:$subFontSize;}
    }
    .service-desc{font-size:$fontSize;color:#999;padding-left:.8rem;}
.popup-service-list{padding:.5rem $pageSpace $footerHeight $pageSpace;
  .popup-service-item{border-bottom:1px solid #eee;padding:.5rem 0;}
}
</style>
